import { gql } from "@apollo/client";

export const USERS = gql`
  query Users($n: Int, $after: String, $where: InputUserOperators) {
    users(n: $n, after: $after, where: $where) {
      edges {
        cursor
        node {
          email
          id
          name
          roles
        }
      }
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      totalCount
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser(
    $email: String!,
    $roles: [UserRole]!
  ) {
    create_platform_user(
      email: $email,
      roles: $roles
    ) {
      edges {
        __typename
        cursor
        node {
          email
          id
          roles
        }
      }
    }
  }
`;

export const DELETE_USER = gql`
  mutation DeleteUser($id: String!) {
    delete_platform_user(id: $id) {
      edges {
        node {
          email
          id
          roles
        }
      }
    }
  }
`;

export const ADD_USER_ROLE = gql`
  mutation AddUserRoles($user_id: String!, $role: UserRole!) {
    add_role(user_id: $id, role: $role) {
      edges {
        node {
          email
          id
          name
          roles
        }
      }
    }
  }
`;

export const DELETE_USER_ROLE = gql`
  mutation DeleteUserRoles($user_id: String!, $role: UserRole!) {
    delete_role(user_id: $id, role: $role) {
      edges {
        node {
          email
          id
          name
          roles
        }
      }
    }
  }
`;